const Loading = () => {

  return (
    <>
      <div className="loading">
        <div className="spinner-border spinnersize" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </>
  );
}

export default Loading;